var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content super-admin-dashboard" }, [
    _c("div", { staticClass: "dashboard-stats-section" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats-grid" },
        _vm._l(3, function (n) {
          return _c("div", { key: n, staticClass: "stat-card" }, [
            _vm._m(1, true),
            _vm._v(" "),
            _vm._m(2, true),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "quick-actions-section" }, [
      _vm._m(3),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "quick-actions-grid" },
        _vm._l(3, function (n) {
          return _c("div", { key: n, staticClass: "quick-action-skeleton" }, [
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: {
                height: "24px",
                width: "24px",
                "border-radius": "50%",
                "margin-bottom": "8px",
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: { height: "16px", width: "100px" },
            }),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard-card branches-table-section" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive p-3" }, [
        _c("table", { staticClass: "table modern-table" }, [
          _c("thead", [
            _c(
              "tr",
              _vm._l(7, function (n) {
                return _c("th", { key: n }, [
                  _c("div", {
                    staticClass: "skeleton-box",
                    staticStyle: { height: "18px", width: "80%" },
                  }),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(5, function (row) {
              return _c(
                "tr",
                { key: row },
                _vm._l(7, function (col) {
                  return _c("td", { key: col }, [
                    _c("div", {
                      staticClass: "skeleton-box",
                      style: `height: 16px; width: ${_vm.getRandomWidth()}%;`,
                    }),
                  ])
                }),
                0
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard-card admissions-section" }, [
      _vm._m(5),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admissions-grid p-3" },
        _vm._l(4, function (n) {
          return _c("div", { key: n, staticClass: "admission-card-skeleton" }, [
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: {
                height: "60px",
                width: "60px",
                "border-radius": "50%",
                margin: "0 auto 16px",
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: {
                height: "32px",
                width: "60px",
                margin: "0 auto 8px",
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: { height: "16px", width: "100px", margin: "0 auto" },
            }),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "charts-container" }, [
      _c(
        "div",
        { staticClass: "charts-row" },
        _vm._l(2, function (n) {
          return _c(
            "div",
            { key: n, staticClass: "chart-container bg-white" },
            [_vm._m(6, true), _vm._v(" "), _vm._m(7, true)]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "28px", width: "200px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "40px", width: "40px", "border-radius": "50%" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-content" }, [
      _c("div", {
        staticClass: "skeleton-box mb-2",
        staticStyle: { height: "32px", width: "80px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "skeleton-box mb-2",
        staticStyle: { height: "18px", width: "120px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "14px", width: "140px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "28px", width: "150px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header-modern" }, [
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "24px", width: "180px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "card-header-modern d-flex justify-content-between align-items-center",
      },
      [
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: { height: "24px", width: "200px" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex gap-2" }, [
          _c("div", {
            staticClass: "skeleton-box",
            staticStyle: { height: "38px", width: "150px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "skeleton-box",
            staticStyle: { height: "38px", width: "150px" },
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "admin-head p-3" }, [
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "24px", width: "120px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p-3" }, [
      _c("div", { staticClass: "d-flex gap-2 mb-3" }, [
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: { height: "38px", width: "150px" },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: { height: "38px", width: "150px" },
        }),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "320px", width: "100%" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }